// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-attachment: fixed;
    font-family: 'Roboto', sans-serif;
    color: #fff;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
.log-workout-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: 500px;
    margin: 40px auto;
    background: rgba(44, 62, 80, 0.9); /* Semi-transparent blue */
    padding: 20px;
    border-radius: 10px;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    color: #000000; /* White text for better contrast */
}

.log-workout-form input[type="number"],
.log-workout-form select,
.log-workout-form input[type="text"] {
    background: rgba(255, 255, 255, 0.2); /* Lighter background for inputs */
    color: #0293a7;
    width: 100%; /* Adjust width to account for padding */
    padding: 10px;
    margin: 8px 0;
    border: 1px solid #ddd;
    border-radius: 6px;
}

  .log-workout-form label {
    display: block;
    margin-bottom: 4px;
  }

  .exercise-group {
    border: 1px solid #eee;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: #e8e5e5de;
  }

  .pair-group {
    border: 1px solid #eee;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: #c0cad1de;
  }

  .custom-exercise {
    border: 1px solid #eee;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: #797979de;
  }
  
  .remove-button, .add-button, .submit-button {
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    margin: 10px 0;
    transition: background-color 0.3s;
  }
  
  .remove-button {
    background-color: #666668;
    color: white;
  }
  
  .add-button {
    background-color: #0f3443; /* Dark blue to match the theme */
    color: white;
  }
  
  .submit-button {
    background-color: #2196F3;
    color: white;
    width: 100%;
    box-sizing: border-box;
  }
  
  /* Adjustments for smaller screens */
  @media (max-width: 768px) {
    .log-workout-form {
      width: auto;
      padding: 15px;
    }
  
    .remove-button, .add-button, .submit-button {
      width: calc(100% - 20px); /* Subtract padding from the width */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/LogWorkoutForm.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;EACZ;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC,EAAE,0BAA0B;IAC7D,aAAa;IACb,mBAAmB;IACnB,kCAA0B;YAA1B,0BAA0B;IAC1B,wCAAwC;IACxC,cAAc,EAAE,mCAAmC;AACvD;;AAEA;;;IAGI,oCAAoC,EAAE,kCAAkC;IACxE,cAAc;IACd,WAAW,EAAE,wCAAwC;IACrD,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;EAEE;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB,EAAE,iCAAiC;IAC5D,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,sBAAsB;EACxB;;EAEA,oCAAoC;EACpC;IACE;MACE,WAAW;MACX,aAAa;IACf;;IAEA;MACE,wBAAwB,EAAE,oCAAoC;IAChE;EACF","sourcesContent":["body {\n    background-attachment: fixed;\n    font-family: 'Roboto', sans-serif;\n    color: #fff;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n  }\n  \n.log-workout-form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    max-width: 500px;\n    margin: 40px auto;\n    background: rgba(44, 62, 80, 0.9); /* Semi-transparent blue */\n    padding: 20px;\n    border-radius: 10px;\n    backdrop-filter: blur(5px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    color: #000000; /* White text for better contrast */\n}\n\n.log-workout-form input[type=\"number\"],\n.log-workout-form select,\n.log-workout-form input[type=\"text\"] {\n    background: rgba(255, 255, 255, 0.2); /* Lighter background for inputs */\n    color: #0293a7;\n    width: 100%; /* Adjust width to account for padding */\n    padding: 10px;\n    margin: 8px 0;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n}\n\n  .log-workout-form label {\n    display: block;\n    margin-bottom: 4px;\n  }\n\n  .exercise-group {\n    border: 1px solid #eee;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    background-color: #e8e5e5de;\n  }\n\n  .pair-group {\n    border: 1px solid #eee;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    background-color: #c0cad1de;\n  }\n\n  .custom-exercise {\n    border: 1px solid #eee;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    background-color: #797979de;\n  }\n  \n  .remove-button, .add-button, .submit-button {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    margin: 10px 0;\n    transition: background-color 0.3s;\n  }\n  \n  .remove-button {\n    background-color: #666668;\n    color: white;\n  }\n  \n  .add-button {\n    background-color: #0f3443; /* Dark blue to match the theme */\n    color: white;\n  }\n  \n  .submit-button {\n    background-color: #2196F3;\n    color: white;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  \n  /* Adjustments for smaller screens */\n  @media (max-width: 768px) {\n    .log-workout-form {\n      width: auto;\n      padding: 15px;\n    }\n  \n    .remove-button, .add-button, .submit-button {\n      width: calc(100% - 20px); /* Subtract padding from the width */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
